<template>
    <div class="orderdrawer">
        <el-drawer
            title="发货单详情"
            width="40%"
            :lock-scroll="false"
            :visible.sync="dialogVisible"
            :before-close="handleClose"
            :direction="direction">
            <div class="drawerorder bgD8D8D8 padding20">
                <div class="mt10 drawerorder_cont">
                  <p>
                    <span class="C787878">订单编号</span>
                    <span class="D1D1D1  ft16">{{drawerdata.orderCode}}</span>
                  </p>
                  <p>
                    <span class="C787878">商品总数</span>
                    <span class="D1D1D1 ft16">YD202006070001</span>
                  </p>
                  <p>
                    <span class="C787878">发货单号</span>
                    <span class="D1D1D1 ft16">YD202006070001</span>
                  </p>
                  <p>
                    <span class="C787878">发货时间</span>
                    <span class="D1D1D1 ft16">YD202006070001</span>
                  </p>
                 <p>
                   <!-- state 订单状态 -->
                    <span class="C787878">发货状态</span>
                    <span class="ft16" :style="'color:'+theme">已经发货</span>
                  </p>
                </div>
                <div class="drawerorder_table">
                    <el-table
                    :header-cell-style="{ textAlign: 'center',fontSize:'12px',background: '#F5F5F5'}"
                    :cell-style="{textAlign: 'center',background:'#fff',fontSize:'13px'}"
                    :data="tableData1"
                    style="width: 100%;border:1px solid #F5F5F5">
                    <el-table-column
                      prop="date"
                      width="130px"
                      label="商品信息">
                      <template>
                          <div class="flex">
                            <p>
                               <img width="40px" height="40px"  src="@/assets/img/biz.png" alt="">
                            </p>
                            <p class="overflow_ellipsis2 ml10">哈哈哈哈哈哈哈哈哈啊哈哈哈哈双哈哈哈哈哈啊哈哈哈哈双哈哈哈啊哈哈哈哈哈哈哈双哈哈哈哈啊哈哈哈哈双手合十很少很少</p>
                          </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      label="商品规格">
                    </el-table-column>
                    <el-table-column
                      prop="address"
                      label="单位">
                    </el-table-column>
                    <el-table-column
                      prop="address"
                      label="数量">
                    </el-table-column>
                  </el-table>
                </div>
            </div>
      </el-drawer>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name:'orderdrawer',
    data(){
        return{
            direction: 'rtl',
            tableData1:[], //暂时补位
        }
    },
    props: {
        visible: { //是否显示
            type: Boolean,
            default: false
        },
        drawerdata:{
            type:Object,
            default:function(){
                return {}
            }
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible
            },
            set(val) {
                this.$emit('update:visible', val) // openCardDialog改变的时候通知父组件
            }
        },
        ...mapGetters({
          theme: 'theme'
        })
    },
    methods:{
        // 关闭
        handleClose () {
            this.$emit('handleClose')
        },
    }
}
</script>

<style lang="scss" scoped>
    .orderdrawer{
              // 弹框
     /deep/ .el-drawer__header{
        font-size: 26px;
        color: #1D1D1D;
      }
      .drawerorder{
        margin: 0px 10px;
        .drawerorder_cont{
          p{
            line-height: 40px;
            span:first-child{
              margin-right:50px;
            }
          }
        }
      }
    }
</style>